/** @type {Array<{
 *   id: string, name: string, description: string,
 *   price: number, salePrice: number|null,
 *   category: string, tags: string[], stock: number,
 *   rating: number, reviewCount: number,
 *   images: string[], createdAt: string
 * }>} */
const products = [
  // ── Electronics (6 items) ──────────────────────────────────
  {
    id: "p001",
    name: "無線藍牙耳機 Pro",
    description: "主動降噪技術，40小時超長續航，配備高清麥克風，適合通勤與工作使用。柔軟耳罩設計，長時間佩戴不疲勞。",
    price: 3990,
    salePrice: 2990,
    category: "electronics",
    tags: ["sale", "hot"],
    stock: 15,
    rating: 4.7,
    reviewCount: 312,
    images: [
      "https://picsum.photos/seed/p001a/600/600",
      "https://picsum.photos/seed/p001b/600/600",
    ],
    createdAt: "2024-03-01",
  },
  {
    id: "p002",
    name: "機械式鍵盤 RGB",
    description: "青軸手感，全鍵無衝突，RGB 背光燈效可自訂，鋁合金外殼堅固耐用，適合電競與程式開發。",
    price: 2490,
    salePrice: null,
    category: "electronics",
    tags: ["new"],
    stock: 8,
    rating: 4.5,
    reviewCount: 178,
    images: [
      "https://picsum.photos/seed/p002a/600/600",
      "https://picsum.photos/seed/p002b/600/600",
    ],
    createdAt: "2024-02-15",
  },
  {
    id: "p003",
    name: "27吋 4K 顯示器",
    description: "IPS 面板，色域覆蓋 sRGB 99%，1ms 反應時間，支援 HDR400，Type-C 單線連接充電與畫面傳輸。",
    price: 12900,
    salePrice: 10900,
    category: "electronics",
    tags: ["sale"],
    stock: 4,
    rating: 4.8,
    reviewCount: 95,
    images: [
      "https://picsum.photos/seed/p003a/600/600",
      "https://picsum.photos/seed/p003b/600/600",
    ],
    createdAt: "2024-01-20",
  },
  {
    id: "p004",
    name: "輕薄筆記型電腦 14\"",
    description: "搭載最新處理器，16GB 記憶體，512GB SSD，重量僅 1.2kg，一次充電可使用 12 小時，商務出差首選。",
    price: 28900,
    salePrice: null,
    category: "electronics",
    tags: ["hot"],
    stock: 6,
    rating: 4.6,
    reviewCount: 241,
    images: [
      "https://picsum.photos/seed/p004a/600/600",
      "https://picsum.photos/seed/p004b/600/600",
    ],
    createdAt: "2024-03-10",
  },
  {
    id: "p005",
    name: "智慧型手錶 Sport",
    description: "GPS 定位、心率監測、血氧偵測，防水 ATM5，支援 iOS/Android，待機時間 7 天。",
    price: 6990,
    salePrice: 5490,
    category: "electronics",
    tags: ["sale", "new"],
    stock: 20,
    rating: 4.4,
    reviewCount: 187,
    images: [
      "https://picsum.photos/seed/p005a/600/600",
      "https://picsum.photos/seed/p005b/600/600",
    ],
    createdAt: "2024-03-05",
  },
  {
    id: "p006",
    name: "無線充電盤 15W",
    description: "支援 Qi 標準，最高 15W 快充，相容 iPhone、Android 所有支援無線充電設備，LED 指示燈設計。",
    price: 890,
    salePrice: null,
    category: "electronics",
    tags: [],
    stock: 0,
    rating: 4.2,
    reviewCount: 422,
    images: [
      "https://picsum.photos/seed/p006a/600/600",
      "https://picsum.photos/seed/p006b/600/600",
    ],
    createdAt: "2023-12-01",
  },

  // ── Clothing (5 items) ────────────────────────────────────
  {
    id: "p007",
    name: "純棉基本款 T恤（白）",
    description: "100% 有機棉，透氣舒適，寬鬆版型適合日常穿搭，提供 S / M / L / XL 尺寸，機洗不縮水。",
    price: 590,
    salePrice: null,
    category: "clothing",
    tags: [],
    stock: 50,
    rating: 4.3,
    reviewCount: 634,
    images: [
      "https://picsum.photos/seed/p007a/600/600",
      "https://picsum.photos/seed/p007b/600/600",
    ],
    createdAt: "2024-01-10",
  },
  {
    id: "p008",
    name: "修身牛仔褲（深藍）",
    description: "彈性丹寧布料，修身剪裁，適合搭配各種上衣，提供 28–38 腰圍選擇，舒適不緊繃。",
    price: 1490,
    salePrice: 990,
    category: "clothing",
    tags: ["sale"],
    stock: 30,
    rating: 4.5,
    reviewCount: 289,
    images: [
      "https://picsum.photos/seed/p008a/600/600",
      "https://picsum.photos/seed/p008b/600/600",
    ],
    createdAt: "2024-02-01",
  },
  {
    id: "p009",
    name: "連帽衛衣（灰）",
    description: "320g 重磅棉，內裡絨毛保暖，袋鼠口袋設計，適合秋冬穿搭，多色可選。",
    price: 1290,
    salePrice: null,
    category: "clothing",
    tags: ["new"],
    stock: 25,
    rating: 4.6,
    reviewCount: 156,
    images: [
      "https://picsum.photos/seed/p009a/600/600",
      "https://picsum.photos/seed/p009b/600/600",
    ],
    createdAt: "2024-03-01",
  },
  {
    id: "p010",
    name: "羊毛大衣（駝色）",
    description: "80% 羊毛混紡，保暖輕盈，修身長版剪裁，適合秋冬正式與休閒場合，乾洗保養。",
    price: 4990,
    salePrice: 3490,
    category: "clothing",
    tags: ["sale", "hot"],
    stock: 10,
    rating: 4.7,
    reviewCount: 98,
    images: [
      "https://picsum.photos/seed/p010a/600/600",
      "https://picsum.photos/seed/p010b/600/600",
    ],
    createdAt: "2023-11-15",
  },
  {
    id: "p011",
    name: "運動壓縮褲（黑）",
    description: "吸濕排汗面料，四向彈力，適合跑步、健身、瑜伽，反光設計提高夜間安全性。",
    price: 890,
    salePrice: null,
    category: "clothing",
    tags: [],
    stock: 0,
    rating: 4.1,
    reviewCount: 203,
    images: [
      "https://picsum.photos/seed/p011a/600/600",
      "https://picsum.photos/seed/p011b/600/600",
    ],
    createdAt: "2023-10-20",
  },

  // ── Home (4 items) ────────────────────────────────────────
  {
    id: "p012",
    name: "北歐風實木餐桌",
    description: "橡木實木桌面，鐵藝桌腳，尺寸 120×70cm，可容納 4 人用餐，簡約設計融入各種居家風格。",
    price: 8900,
    salePrice: null,
    category: "home",
    tags: ["hot"],
    stock: 5,
    rating: 4.8,
    reviewCount: 67,
    images: [
      "https://picsum.photos/seed/p012a/600/600",
      "https://picsum.photos/seed/p012b/600/600",
    ],
    createdAt: "2024-01-05",
  },
  {
    id: "p013",
    name: "香氛蠟燭禮盒組",
    description: "天然大豆蠟，法國香精，燃燒時間約 40 小時，附精美禮盒包裝，適合送禮自用。共 3 種香氛：薰衣草、玫瑰、雪松。",
    price: 890,
    salePrice: 690,
    category: "home",
    tags: ["sale", "new"],
    stock: 40,
    rating: 4.9,
    reviewCount: 341,
    images: [
      "https://picsum.photos/seed/p013a/600/600",
      "https://picsum.photos/seed/p013b/600/600",
    ],
    createdAt: "2024-02-14",
  },
  {
    id: "p014",
    name: "空氣清淨機 HEPA",
    description: "H13 HEPA 濾網，可過濾 PM2.5、花粉、寵物毛屑，適用 25 坪空間，靜音模式運作聲音低於 25dB。",
    price: 6990,
    salePrice: null,
    category: "home",
    tags: [],
    stock: 12,
    rating: 4.5,
    reviewCount: 128,
    images: [
      "https://picsum.photos/seed/p014a/600/600",
      "https://picsum.photos/seed/p014b/600/600",
    ],
    createdAt: "2024-01-25",
  },
  {
    id: "p015",
    name: "珪藻土浴室踏墊",
    description: "天然珪藻土，快速吸水，30分鐘乾燥，防滑底層設計，尺寸 60×40cm，適合浴室廁所使用。",
    price: 690,
    salePrice: 490,
    category: "home",
    tags: ["sale"],
    stock: 60,
    rating: 4.3,
    reviewCount: 512,
    images: [
      "https://picsum.photos/seed/p015a/600/600",
      "https://picsum.photos/seed/p015b/600/600",
    ],
    createdAt: "2023-12-10",
  },

  // ── Books (3 items) ───────────────────────────────────────
  {
    id: "p016",
    name: "深度學習入門（第二版）",
    description: "從零開始學習深度學習，包含 NumPy 實作範例，適合工程師與資料科學初學者，附完整程式碼下載。",
    price: 580,
    salePrice: null,
    category: "books",
    tags: ["hot"],
    stock: 30,
    rating: 4.6,
    reviewCount: 287,
    images: [
      "https://picsum.photos/seed/p016a/600/600",
      "https://picsum.photos/seed/p016b/600/600",
    ],
    createdAt: "2024-02-20",
  },
  {
    id: "p017",
    name: "Clean Code 無瑕的程式碼",
    description: "軟體開發經典著作，Robert C. Martin 著，教你如何寫出易讀、易維護的高品質程式碼。中文版精譯。",
    price: 620,
    salePrice: 490,
    category: "books",
    tags: ["sale"],
    stock: 20,
    rating: 4.8,
    reviewCount: 453,
    images: [
      "https://picsum.photos/seed/p017a/600/600",
      "https://picsum.photos/seed/p017b/600/600",
    ],
    createdAt: "2024-01-15",
  },
  {
    id: "p018",
    name: "設計的文法",
    description: "探索視覺設計的基本原則，從色彩、排版到構圖，適合設計師、產品經理與所有對視覺藝術有興趣的讀者。",
    price: 480,
    salePrice: null,
    category: "books",
    tags: ["new"],
    stock: 15,
    rating: 4.4,
    reviewCount: 132,
    images: [
      "https://picsum.photos/seed/p018a/600/600",
      "https://picsum.photos/seed/p018b/600/600",
    ],
    createdAt: "2024-03-08",
  },

  // ── Sports (4 items) ──────────────────────────────────────
  {
    id: "p019",
    name: "瑜伽墊 6mm（紫）",
    description: "天然橡膠材質，防滑紋路設計，6mm 厚度保護關節，附背包繩方便攜帶，尺寸 183×61cm。",
    price: 1290,
    salePrice: null,
    category: "sports",
    tags: [],
    stock: 25,
    rating: 4.5,
    reviewCount: 367,
    images: [
      "https://picsum.photos/seed/p019a/600/600",
      "https://picsum.photos/seed/p019b/600/600",
    ],
    createdAt: "2024-02-10",
  },
  {
    id: "p020",
    name: "啞鈴組 5–25kg",
    description: "可調式啞鈴，每組包含 5、10、15、20、25kg，橡膠包覆防刮地板，附收納架，適合居家健身。",
    price: 5900,
    salePrice: 4490,
    category: "sports",
    tags: ["sale", "hot"],
    stock: 8,
    rating: 4.7,
    reviewCount: 214,
    images: [
      "https://picsum.photos/seed/p020a/600/600",
      "https://picsum.photos/seed/p020b/600/600",
    ],
    createdAt: "2024-01-30",
  },
  {
    id: "p021",
    name: "專業跑鞋 CloudRun",
    description: "碳纖維彈片中底，回彈率 85%，透氣網面鞋面，適合長跑與競速，重量僅 210g。",
    price: 4290,
    salePrice: null,
    category: "sports",
    tags: ["new"],
    stock: 18,
    rating: 4.6,
    reviewCount: 178,
    images: [
      "https://picsum.photos/seed/p021a/600/600",
      "https://picsum.photos/seed/p021b/600/600",
    ],
    createdAt: "2024-03-12",
  },
  {
    id: "p022",
    name: "跳繩計數器款",
    description: "LCD 計數顯示，可記錄跳繩次數與時間，鋼絲繩芯速度更快，長度可調節，適合各種身高。",
    price: 390,
    salePrice: null,
    category: "sports",
    tags: [],
    stock: 55,
    rating: 4.2,
    reviewCount: 589,
    images: [
      "https://picsum.photos/seed/p022a/600/600",
      "https://picsum.photos/seed/p022b/600/600",
    ],
    createdAt: "2023-11-20",
  },
];

export default products;
